import script from "./promotionCardNew.vue?vue&type=script&setup=true&lang=ts"
export * from "./promotionCardNew.vue?vue&type=script&setup=true&lang=ts"

import "./promotionCardNew.vue?vue&type=style&index=0&id=7035bb64&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7035bb64"]])

export default __exports__